export const KEY_NUMBERS_1_CONSTANTS = {
    DEFAULT_ROW: {
      id: "1",
      meta_title: "1000+",
      meta_subtitle: "Students Enrolled",
      meta_priority: 1,
      meta_title_text_color: "#FFFFFF",
      meta_subtitle_text_color: "#FFFFFF",
      meta_background_color: "#BE2330",
      meta_status: true,
    },
  
    KEY_NUMBERS_FIELDS_CONFIG: [
      {
        fieldName: "status",
        label: "Key Numbers Status",
        value: false,
        valueType: "boolean",
        filedType: "TOGGLE",
        placeholder: "Enable/Disable Key Numbers",
        required: false,
        defaultValue: false,
      },
      {
        fieldName: "background_color",
        label: "Background Color",
        value: "#BE2330",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter background color (e.g., #BE2330)",
        required: false,
        defaultValue: "#BE2330",
      },
    ],
  
    METADATA_FIELDS: [
      {
        header: "Title",
        fieldName: "meta_title",
        value: "",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Title (e.g., 10, 1k)",
      },
      {
        header: "Title Text Color",
        fieldName: "meta_title_text_color",
        value: "#FFFFFF",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter title text color (e.g., #FFFFFF)",
        defaultValue: "#FFFFFF",
      },
      {
        header: "Subtitle",
        fieldName: "meta_subtitle",
        value: "",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Subtitle",
      },
      {
        header: "Subtitle Text Color",
        fieldName: "meta_subtitle_text_color",
        value: "#FFFFFF",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter subtitle text color (e.g., #FFFFFF)",
        defaultValue: "#FFFFFF",
      },
      {
        header: "Priority",
        fieldName: "meta_priority",
        value: "",
        valueType: "number",
        filedType: "INPUT",
        placeholder: "Enter Priority",
        required: true,
      },
      {
        header: "Status",
        fieldName: "meta_status",
        value: true,
        valueType: "boolean",
        filedType: "TOGGLE",
        placeholder: "Enable/Disable this item",
        defaultValue: true,
      },
    ]
  };